const DEFAULT_ALLOWED_IMAGE_EXTENSIONS = ['jpg', 'jpeg', 'png', 'webp', 'avif']

const allowedExtensionsPattern = (
  allowedExtensions = DEFAULT_ALLOWED_IMAGE_EXTENSIONS
) => allowedExtensions.join('|')

export const ImageValidationHelper = {
  isValidImageSize(imageSize, maxAllowedSize) {
    return imageSize <= maxAllowedSize
  },

  isValidImageFormat(
    imageName = '',
    allowedExtensions = DEFAULT_ALLOWED_IMAGE_EXTENSIONS
  ) {
    return new RegExp(
      `\\.(${allowedExtensionsPattern(allowedExtensions)})$`
    ).test(imageName.toLowerCase())
  },

  isValidImageName(
    imageName = '',
    allowedExtensions = DEFAULT_ALLOWED_IMAGE_EXTENSIONS
  ) {
    return new RegExp(
      `^[\\w- ]*\\.(${allowedExtensionsPattern(allowedExtensions)})$`
    ).test(imageName.toLowerCase())
  },

  isValidImageNameLength(imageName = '', maxAllowedNameLength) {
    return imageName?.length >= 1 && imageName?.length <= maxAllowedNameLength
  }
}
